// extracted by mini-css-extract-plugin
module.exports = {"banner":"_ucxzik57","badge":"_ZgJTzC48","icon":"_Gs6SsYJ9","text":"_IUMTyLVa"};